'use strict';

// https://gist.github.com/ShirtlessKirk/2134376

var luhnCheck = (function (arr) {
    return function (ccNum) {
        var len = ccNum.length;
        var bit = 1;
        var sum = 0;
        var val;

        while (len) {
            val = parseInt(ccNum.charAt(--len), 10);
            sum += (bit ^= 1) ? arr[val] : val;
        }

        return sum && sum % 10 === 0;
    };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

var cvvCheck = function (cvv) {
    return (/^[0-9]{3,4}$/).test(cvv);    
};

var initCardExpiry = function(){
    var ccSave = $('#CreditCardForm #applyBtn');
    ccSave.on('click', function(e){
        validateCardExpiry(this, true);
    });
	
    $('.card-expiry.month, .card-expiry.year').on('change blur', function(){
        validateCardExpiry(this);
    });
};

var validateCardExpiry = function(el, checkEmpty){
    // need to declare specifically in order not to confuse with other forms with similar inputs
    var $this = $(el);
    var $month = $this.closest('form').find('.card-expiry.month');
    var $year = $this.closest('form').find('.card-expiry.year');
    var $submit = $this.closest('form').find('button[type="submit"]');
    var hasError = false;
	
    var now = new Date();
    var nowMonth = now.getMonth() + 1; 
    var nowYear = now.getFullYear();
	
    $month.siblings('span.error').remove();
    $month.removeClass('error');
    $year.removeClass('error');
    $submit.prop('disabled', false);
	
    // validate only on form submit
    if(checkEmpty && (!$month.val() || !$year.val())){
        $('<span class="error">' + Resources.INVALID_CARDEXPIRY + '</span>').insertBefore($month);
        hasError = true;
	
        // validate only if month and year has value, otherwise, ignore
    } else if($month.val() && $year.val() && $month.val() < nowMonth && $year.val() <= nowYear){
        $('<span class="error">' + Resources.VALIDATE_CARDEXPIRY + '</span>').insertBefore($month);
        hasError = true;
    }
	
    // highlight inputs if expiry has error 
    if(hasError){
        $month.addClass('error');
        $year.addClass('error');
    }
	
    // disable button if there are errors -- // change by ticket shi-5388
//	if($this.closest('form').find('span.error').length > 0){
//		$submit.prop('disabled', true);
//	}
};

export default {
    init: function () {
        initCardExpiry();
    }
};
